import { render, staticRenderFns } from "./payRecord.vue?vue&type=template&id=0d80e778&scoped=true"
import script from "./payRecord.vue?vue&type=script&lang=js"
export * from "./payRecord.vue?vue&type=script&lang=js"
import style0 from "./payRecord.vue?vue&type=style&index=0&id=0d80e778&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d80e778",
  null
  
)

export default component.exports